function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { base64Encode } from '@finect/front-utils/base64';
import ACTIONS from '../constants';
const contentModelize = model => model.type === 'article' ? _objectSpread(_objectSpread({}, model), {}, {
  body: _objectSpread(_objectSpread({}, model.body), {}, {
    text: base64Encode(model.body.text)
  })
}) : model;
export function content() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    tags: [],
    tag: {
      fetching: false,
      fetched: false,
      model: null,
      contents: {
        items: [],
        fetching: false,
        fetched: false,
        paging: {
          links: [],
          totalItems: 0,
          limit: 10
        }
      },
      profiles: {
        items: [],
        fetching: false,
        fetched: false
      }
    },
    tagArticles: {
      items: [],
      fetching: false,
      fetched: false,
      paging: {
        links: [],
        totalItems: 0,
        limit: 10
      }
    },
    hash: '',
    article: {
      model: {},
      fetching: false,
      fetched: false,
      request: {},
      notFound: false
    },
    articleComments: {
      items: [],
      paging: {
        links: [],
        totalItems: 0,
        limit: 5
      },
      request: {},
      fetching: false,
      fetched: false
    },
    groups: {
      items: [],
      paging: {
        links: [],
        totalItems: 0,
        limit: 24
      },
      request: {
        filters: {
          order: null
        }
      },
      fetching: false,
      fetched: false
    },
    manufacturers: {
      items: [],
      fetching: false,
      fetched: false
    },
    enterpriseAdvisers: {
      items: [],
      fetching: false,
      fetched: false
    },
    videos: {
      items: [],
      paging: {
        links: [],
        totalItems: 0,
        limit: 12
      },
      request: {
        filters: {
          filter: null
        }
      },
      fetching: false,
      fetched: false
    },
    banks: {
      items: [],
      fetching: false,
      fetched: false
    },
    questions: {},
    reviews: {}
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ACTIONS.SET_TAG_FETCHING_STATUS:
      {
        const newState = _objectSpread({}, state);
        newState.tag = _objectSpread(_objectSpread({}, state.tag), {
          fetching: action.fetching,
          fetched: action.fetched
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case ACTIONS.SET_TAG:
      {
        const newState = _objectSpread({}, state);
        if (!action.tag) {
          newState.tag = _objectSpread(_objectSpread({}, state.tag), {}, {
            model: action.tag,
            fetching: false,
            fetched: true
          });
          return _objectSpread(_objectSpread({}, state), newState);
        }
        newState.tag = _objectSpread(_objectSpread({}, state.tag), {}, {
          model: action.tag,
          fetching: false,
          fetched: true
        });
        const NEW_TAG = {
          model: action.tag,
          videos: {
            items: [],
            paging: {
              links: [],
              totalItems: 0,
              limit: 24
            },
            request: {},
            fetching: false,
            fetched: true
          }
        };
        const tag = newState.tags.find(item => item.model.id === action.tag.id);
        const newTag = tag ? _objectSpread(_objectSpread({}, tag), {
          model: action.tag
        }) : NEW_TAG;
        newState.tags = [...newState.tags.filter(item => item.model.id !== action.tag.id), newTag];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case ACTIONS.SET_TAG_ENTITIES_FETCHING_STATUS:
      {
        const newState = _objectSpread({}, state);
        const tagIndex = newState.tags.findIndex(item => item.model.id === action.entityId);
        newState.tags[tagIndex][action.contentType].fetching = action.fetching;
        newState.tags[tagIndex][action.contentType].fetched = action.fetched;
        newState.hash += '-fetching';
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case ACTIONS.SET_TAG_VIDEOS:
      {
        const newState = _objectSpread({}, state);
        const tagIndex = newState.tags.findIndex(item => item.model.id === action.tagId);
        const newTag = _objectSpread({}, newState.tags[tagIndex]);
        newTag.videos = _objectSpread(_objectSpread({}, newTag.videos), {
          items: [...action.videos],
          fetching: false,
          fetched: true
        });
        newState.tags[tagIndex] = _objectSpread({}, newTag);
        newState.hash = newState.tags[tagIndex].videos.items.map(item => item.id).join(',');
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_TAGS':
      {
        const newState = _objectSpread({}, state);
        newState.tags = [...action.tags];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ARTICLE':
      {
        const newState = _objectSpread({}, state);
        newState.article.model = _objectSpread(_objectSpread({}, action.article), {
          body: {
            text: base64Encode(action.article.body.text)
          },
          metadata: _objectSpread({}, action.article.body.metadata),
          url: action.article.body.url
        });
        newState.article.fetching = false;
        newState.article.fetched = true;
        newState.article.notFound = false;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_ARTICLE':
      {
        const newState = _objectSpread({}, state);
        newState.article.model = {};
        newState.article.fetching = false;
        newState.article.fetched = false;
        newState.article.notFound = false;
        newState.articleComments = {
          items: [],
          paging: {
            links: [],
            totalItems: 0,
            limit: 5
          },
          request: {},
          fetching: false,
          fetched: false
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_LIKE_ARTICLE':
      {
        const newState = _objectSpread({}, state);
        action.like ? newState.article.model.socialStats.likes -= 1 : newState.article.model.socialStats.likes += 1;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ARTICLE_NOT_FOUND':
      {
        const newState = _objectSpread({}, state);
        newState.article.fetching = false;
        newState.article.fetched = true;
        newState.article.notFound = true;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ARTICLE_COMMENTS':
      {
        const newState = _objectSpread({}, state);
        const oldComments = [...state.articleComments.items];
        newState.articleComments.items = [...action.comments, ...oldComments];
        newState.articleComments.paging = action.paging;
        newState.articleComments.fetching = false;
        newState.articleComments.fetched = true;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ARTICLE_USER_COMMENT':
      {
        const newState = _objectSpread({}, state);
        const oldComments = [...state.articleComments.items];
        newState.articleComments.items = [...oldComments, action.comment];
        newState.articleComments.paging.totalItems += 1;
        newState.article.model.stats.comments += 1;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ARTICLE_COMMENTS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.articleComments.fetching = action.fetching;
        newState.articleComments.fetched = action.fetched;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_GROUPS':
      {
        const newState = _objectSpread({}, state);
        const oldGroups = [...state.groups.items];
        const oldGroupsIds = oldGroups.map(item => item.id);
        newState.groups.items = [...oldGroups, ...action.groups.filter(group => !oldGroupsIds.includes(group.id)).map(item => _objectSpread(_objectSpread({}, item), {
          disclaimers: []
        }))];
        newState.groups.paging = action.paging;
        newState.groups.fetching = false;
        newState.groups.fetched = true;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_GROUPS':
      {
        const newState = _objectSpread({}, state);
        newState.groups.items = [];
        newState.groups.paging = null;
        newState.groups.fetching = false;
        newState.groups.fetched = false;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_GROUPS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.groups.fetching = action.fetching;
        newState.groups.fetched = action.fetched;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_GROUPS_WITH_FILTERS':
      {
        const newState = _objectSpread({}, state);
        newState.groups.items = [...action.groups];
        newState.groups.paging = action.paging;
        newState.groups.fetching = false;
        newState.groups.fetched = true;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_GROUPS_FILTERS':
      {
        const newState = _objectSpread({}, state);
        newState.groups.request.filters.order = action.filters;
        newState.groups.fetching = true;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_MANUFACTURERS':
      {
        const oldManufacturers = [...state.manufacturers.items];
        return _objectSpread(_objectSpread({}, state), {
          manufacturers: {
            items: [...oldManufacturers, ...action.manufacturers],
            fetched: true,
            fetching: false
          }
        });
      }
    case 'SET_MANUFACTURER_STOREFRONTS':
      {
        const manufacturers = [...state.manufacturers.items];
        const newManufacturer = _objectSpread(_objectSpread({}, manufacturers.find(item => item.alias === action.manufacturer)), {}, {
          storefronts: action.storefronts
        });
        const indexNewManufacturer = manufacturers.findIndex(item => item.alias === action.manufacturer);
        const items = manufacturers.filter(item => item.alias !== action.manufacturer);
        items.splice(indexNewManufacturer, 0, newManufacturer);
        return _objectSpread(_objectSpread({}, state), {}, {
          manufacturers: _objectSpread(_objectSpread({}, state.manufacturers), {
            items
          })
        });
      }
    case 'SET_MANUFACTURER_CONTENTS':
      {
        const manufacturers = [...state.manufacturers.items];
        const newManufacturer = _objectSpread(_objectSpread({}, manufacturers.find(item => item.alias === action.manufacturer)), {}, {
          contents: action.contents
        });
        const indexNewManufacturer = manufacturers.findIndex(item => item.alias === action.manufacturer);
        const items = manufacturers.filter(item => item.alias !== action.manufacturer);
        items.splice(indexNewManufacturer, 0, newManufacturer);
        return _objectSpread(_objectSpread({}, state), {}, {
          manufacturers: _objectSpread(_objectSpread({}, state.manufacturers), {
            items
          })
        });
      }
    case 'SET_ENTERPRISE_ADVISERS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          enterpriseAdvisers: {
            items: action.enterprises,
            fetching: false,
            fetched: true
          }
        });
      }
    case 'SET_VIDEOS':
      {
        const newVideos = _objectSpread({}, state.videos);
        newVideos.paging = action.paging;
        newVideos.items = [...state.videos.items, ...action.videos];
        newVideos.fetching = false;
        newVideos.fetched = true;
        return _objectSpread(_objectSpread({}, state), {
          videos: _objectSpread({}, newVideos)
        });
      }
    case 'SET_VIDEOS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.videos.fetched = action.fetched;
        newState.videos.fetching = action.fetching;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_VIDEOS_WITH_FILTERS':
      {
        const newState = _objectSpread({}, state);
        newState.videos.paging = action.paging;
        newState.videos.items = [...action.videos];
        newState.videos.fetching = false;
        newState.videos.fetched = true;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_VIDEOS_FILTERS':
      {
        const newState = _objectSpread({}, state);
        newState.videos.fetching = true;
        newState.videos.request.filters.filter = action.filters;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_SUBSCRIPTION_GROUP':
      {
        const newState = _objectSpread({}, state);
        action.follow ? newState.groups.items.find(group => group.id === action.id).stats.subscribers += 1 : newState.groups.items.find(group => group.id === action.id).stats.subscribers -= 1;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case ACTIONS.SET_TAG_CONTENTS:
      {
        const newState = _objectSpread({}, state);
        newState.tag = _objectSpread(_objectSpread({}, state.tag), {}, {
          contents: {
            items: [...(action.add ? state.tag.contents.items : []), ...action.contents.map(contentModelize)],
            fetching: false,
            fetched: true,
            paging: action.paging
          }
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case ACTIONS.SET_TAG_CONTENTS_FETCHING_STATUS:
      {
        const newState = _objectSpread({}, state);
        newState.tag = _objectSpread(_objectSpread({}, state.tag), {}, {
          contents: _objectSpread(_objectSpread({}, state.tag.contents), {}, {
            fetching: action.fetching
          })
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ADVISERS_PROFILES':
      {
        const newState = _objectSpread({}, state);
        newState.tag = _objectSpread(_objectSpread({}, state.tag), {}, {
          profiles: {
            items: action.profiles,
            fetching: false,
            fetched: true
          }
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_QUESTIONS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        if (!newState.questions[action.id]) {
          newState.questions[action.id] = {
            items: [],
            paging: {},
            request: {},
            fetching: false,
            fetched: false
          };
        }
        const data = _objectSpread(_objectSpread({}, newState.questions[action.id]), {
          fetching: action.fetching,
          fetched: action.fetched
        });
        const newObject = {
          [action.id]: data
        };
        newState.questions = _objectSpread(_objectSpread({}, newState.questions), newObject);
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_QUESTIONS':
      {
        const newState = _objectSpread({}, state);
        if (!newState.questions[action.id]) {
          newState.questions[action.id] = {
            items: [],
            paging: {},
            request: {},
            fetching: false,
            fetched: false
          };
        }
        const data = _objectSpread({}, newState.questions[action.id]);
        data.items = action.request.offset ? [...data.items, ...action.items] : [...action.items];
        data.paging = action.paging;
        data.fetching = false;
        data.fetched = true;
        const newObject = {
          [action.id]: data
        };
        newState.questions = _objectSpread(_objectSpread({}, newState.questions), newObject);
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_REVIEWS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        if (!newState.reviews[action.id]) {
          newState.reviews[action.id] = {
            items: [],
            paging: {},
            request: {},
            fetching: false,
            fetched: false
          };
        }
        const data = _objectSpread(_objectSpread({}, newState.reviews[action.id]), {
          fetching: action.fetching,
          fetched: action.fetched
        });
        const newObject = _objectSpread({}, {
          [action.id]: _objectSpread({}, data)
        });
        return _objectSpread(_objectSpread({}, state), {
          reviews: _objectSpread(_objectSpread({}, newState.reviews), newObject)
        });
      }
    case 'SET_REVIEWS':
      {
        const newState = _objectSpread({}, state);
        if (!newState.reviews[action.id]) {
          newState.reviews[action.id] = {
            items: [],
            paging: {},
            request: {},
            fetching: false,
            fetched: false
          };
        }
        const data = _objectSpread({}, newState.reviews[action.id]);
        const newItems = action.request.offset ? [...data.items, ...action.items] : [...action.items];
        const newReview = _objectSpread(_objectSpread({}, {
          fetching: false,
          fetched: true
        }), {
          items: [...newItems],
          paging: action.paging,
          request: action.request
        });
        const newReviews = {
          reviews: _objectSpread(_objectSpread({}, newState.reviews), {
            [action.id]: newReview
          })
        };
        return _objectSpread(_objectSpread({}, state), newReviews);
      }
    case 'SET_ARTICLES_TAG_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.tagArticles = _objectSpread(_objectSpread({}, state.tagArticles), {}, {
          fetching: action.fetching
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ARTICLES_TAG':
      {
        const newState = _objectSpread({}, state);
        newState.tagArticles = _objectSpread(_objectSpread({}, state.tagArticles), {}, {
          items: [...action.contents.map(contentModelize)],
          fetching: false,
          fetched: true,
          paging: action.paging
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_BANKS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.banks = {
          items: newState.banks.items,
          fetching: true,
          fetched: false
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_BANKS':
      {
        const newState = _objectSpread({}, state);
        newState.banks = {
          items: [...action.banks.map(item => _objectSpread(_objectSpread({}, item), {}, {
            link: `/bancos/${item.alias}`,
            image: `https://www.finect.com/image/${item.icon}`
          }))],
          fetching: false,
          fetched: true
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_BANKS':
      {
        const newState = _objectSpread({}, state);
        newState.banks = {
          items: [],
          fetching: false,
          fetched: false
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    default:
      return state;
  }
}